export const e2e = {
  bind(el, binding) {
    const value = binding.value
      ? binding.arg + ':' + binding.value
      : binding.arg;
    el.setAttribute(`data-e2e`, value);
  },
};
